@if (report()) {
	<div>
		<div class="student-name">{{ studentUuid() | displayName: 'user' | async }}</div>
		<div class="skills-summary">
			@for (skill of sortedSkills(); track skill) {
				<app-white-panel
					[ngClass]="[skill.code]"
					[class.selected]="selectedSkill() === skill.code"
					(click)="selectSkill(skill.code)"
				>
					<div class="center">
						<div class="skill-name">{{ skill.label }}</div>
						<div class="level">{{ report()!.studentSkills[skill.code] || 0 }}</div>
						<div class="progress-bar"></div>
					</div>
				</app-white-panel>
			}
			<app-white-panel class="composite">
				<div class="center">
					<div class="skill-name">Composite</div>
					<div class="level">{{ report()!.compositeAverage || 0 }}</div>
					<div class="progress-bar"></div>
				</div>
			</app-white-panel>
		</div>

		<app-white-panel class="skill-progress">
			<div class="skill-progress-header">
				<div class="skill-name">{{ selectedSkill() | titlecase }}</div>
				<app-skill-progress
					[report]="report()"
					[selectedSkill]="selectedSkill()"
					[selectedRubricLevel]="selectedRubricLevel()"
					(onSelect)="selectProgressItem($event)"
					#progress
				></app-skill-progress>
			</div>
		</app-white-panel>

		@if (
			selectedProgressItem() &&
			selectedProgressItem()!.content &&
			selectedProgressItem()!.content.content_text &&
			selectedProgressItem()!.content.content_text.length > 0 &&
			selectedProgressItem()!.content.content_text[0].name
		) {
			<app-white-panel class="title-and-progress-date">
				<div>{{ selectedProgressItem()!.content.content_text[0].name || 'Unknown' }}</div>
				<div>{{ selectedProgressItem()!.take.start_date | date: 'mediumDate' }}</div>
			</app-white-panel>

			<app-white-panel class="activity-details-container">
				<app-collapsible-section title="Skill Descriptors" class="skill-descriptors">
					@if (selectedSkillDescriptors().length > 0 && selectedRubricLevel()) {
						<div>
							<div
								class="title"
								[class.level1]="selectedRubricLevel()!.level === 1"
								[class.level2]="selectedRubricLevel()!.level === 2"
								[class.level3]="selectedRubricLevel()!.level === 3"
								[class.level4]="selectedRubricLevel()!.level === 4"
								[class.level5]="selectedRubricLevel()!.level === 5"
								[class.level6]="selectedRubricLevel()!.level === 6"
							>
								{{ selectedRubricLevel()!.name }} - {{ selectedSkill() | titlecase }}
							</div>
							<ul>
								@for (descriptor of selectedSkillDescriptors(); track descriptor) {
									<li>{{ descriptor }}</li>
								}
							</ul>
						</div>
					}
				</app-collapsible-section>

				@if (selectedProgressItem() && containsVisualDescription() && isCoachActivity()) {
					<app-collapsible-section title="Task Description" class="task-description">
						<div [innerHTML]="selectedProgressItem()!.activity.activity_text[0].description_html"></div>
					</app-collapsible-section>
				}

				@if (selectedProgressItem()) {
					@if (isCoachActivity()) {
						<app-collapsible-section title="Student Response" class="student-response" [overflow]="true">
							@if (selectedProgressItem()!.take.take) {
								<app-coach-chat
									[takeNumber]="selectedProgressItem()!.take.take"
									[contentText]="selectedProgressItem()!.content.content_text[0]"
									[studentUuid]="studentUuid()"
								></app-coach-chat>
							}
						</app-collapsible-section>
					}

					@if (isWireframeActivity()) {
						<app-collapsible-section title="Student Response" class="wireframe-report" [overflow]="true">
							<app-wireframe-report
								[takeNumber]="selectedProgressItem()!.take.take"
								[contentText]="selectedProgressItem()!.content.content_text[0]"
								[studentUuid]="studentUuid()"
							></app-wireframe-report>
						</app-collapsible-section>
					}
				}

				@if (selectedProgressItem() && hasStrengths()) {
					<app-collapsible-section title="Strengths" class="strengths">
						<app-stride-assessment
							[assessments]="selectedProgressItem()!.assessment?.strengths || []"
						></app-stride-assessment>
					</app-collapsible-section>
				}

				@if (selectedProgressItem() && hasNeedsImprovement()) {
					<app-collapsible-section title="Needs Improvement" class="needs-improvement">
						<app-stride-assessment
							[assessments]="selectedProgressItem()!.assessment?.needsImprovement || []"
						></app-stride-assessment>
					</app-collapsible-section>
				}

				@if (selectedProgressItem() && hasStrideForward()) {
					<app-collapsible-section title="Stride Forward" class="stride-forward">
						<app-stride-assessment
							[assessments]="selectedProgressItem()!.assessment?.strideForward || []"
						></app-stride-assessment>
					</app-collapsible-section>
				}
			</app-white-panel>
		}
	</div>
}
